module.exports = __webpack_public_path__ + "img/Instagram.5ee10877.svg";